import config from "../../config";
import logo from '../../logo.png';
import { Link } from 'react-router-dom';
import GTranslate from "../GTranslate";

export default function Footer() {
    return (
        <>
            <footer className="py-20 px-6 border-t-2 border-blue-900 md:px-16 bg-white text-sm w-full">
                <div className="flex flex-col gap-8 md:gap-14 md:flex-row">
                    <div className="md:w-1/3 w-full">
                        <div className="relative w-fit md:mx-0 mx-auto mb-6">

                            <img src={logo} alt="logo" className="h-8" />

                            <span className="font-semibold text-3xl absolute -top-2 xl:-right-5 -right-4">&reg;</span>
                        </div>
                        <p className="text-sm md:text-start text-center">
                            We offer the first mediation solution for small disputes,
                            fully digital and assisted by Artificial Intelligence.
                        </p>
                    </div>

                    <div className="col-span-3">
                        <div className="grid lg:grid-cols-3 grid-cols-1 gap-6 text-center lg:text-start">
                            <div>
                                <h4 className="text-lg font-semibold">Links</h4>
                                <ul className="mt-3">
                                    <li className="my-2">
                                        <Link to="/" className=" transition delay-200 font-semibold hover:text-blue-800 text-xs">Home</Link>
                                    </li>
                                    <li className="my-2">
                                        <Link to="/the-vision" className=" transition delay-200 font-semibold hover:text-blue-800 text-xs">Vision</Link>
                                    </li>
                                    <li className="my-2">
                                        <Link to="/guidelines" className=" transition delay-200 font-semibold hover:text-blue-800 text-xs">Guidelines</Link>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h4 className="text-lg mx-auto font-semibold">Legal</h4>
                                <ul className="mt-3">
                                    <li className="my-2">
                                        <Link to="/terms" preventScrollReset={false} className="transition delay-200 font-semibold hover:text-blue-800 text-xs">Terms Of Use</Link>
                                    </li>
                                    <li className="my-2">
                                        <Link to="/policy" preventScrollReset={false} className="transition delay-200 font-semibold hover:text-blue-800 text-xs">Privacy Policy</Link>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h4 className="text-lg mx-auto font-semibold">Contact Us</h4>
                                <ul className="mt-3">
                                    <li className="my-2">
                                        <a href="mailto:support@northmeadtechnologies.com" className="transition delay-200 font-semibold items-center gap-2 justify-center lg:justify-start flex hover:text-blue-900 text-blue-800 text-xs">
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                                                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                                                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                                                </svg>
                                            </span>
                                            <span>
                                                support@northmeadgroup.com
                                            </span>
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center mt-6">
                    <span className=" text-sm text-gray-900">©{config.APP_NAME}. All right reserved.</span>
                </div>
                <div className="mt-3 flex justify-center items-center w-full">
                    <GTranslate />
                </div>
            </footer>
        </>
    );
}